/*
  PPV Duftfinder – Empfehlungslogik (Datenvertrag „Duftprofil“ v1, Metafeld duftprofil.analyse)
  Ein Katalog-Eintrag: { h: Handle, t: Titel, b: Marke, i: Bild, p: Preis 2 ml, id: Varianten-ID 2 ml, a: lieferbar (1/0),
    r: Bestseller-Rang (0 = meistverkauft), d: Dufttyp, s: Jahreszeit, o: Anlass, y: Stil } – d/s/o/y als { key: wert }.
  Gerechnet wird mit Anteilen je Block (wert / Summe des Blocks), wie im Vertrag vorgegeben.
  1. Stufen: Ein Duft muss erst die harten Bedingungen erfüllen (Richtung, Ausschlüsse, Nie-Regeln, Stil, Jahreszeit, Anlass).
     Bleiben zu wenige übrig, wird stufenweise gelockert – zuerst Anlass, dann Jahreszeit, zuletzt die Richtung.
  2. Innerhalb einer Stufe entscheidet die gewichtete Übereinstimmung.
  3. Alternativen: ähnliche Profile, gleiche Marke und gleiche Duftlinie bekommen Abzüge (Vielfalt).
  Läuft im Browser (window.PPVDuftfinderEngine) und in Node (Tests).
*/
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.PPVDuftfinderEngine = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var LABELS = {
    animalisch: 'Animalisch', aquatisch: 'Aquatisch', blumig: 'Blumig', chypre: 'Chypre', cremig: 'Cremig', erdig: 'Erdig',
    fougere: 'Fougère', frisch: 'Frisch', fruchtig: 'Fruchtig', gourmand: 'Gourmand', gruen: 'Grün', harzig: 'Harzig',
    holzig: 'Holzig', ledrig: 'Ledrig', orientalisch: 'Orientalisch', pudrig: 'Pudrig', rauchig: 'Rauchig', suess: 'Süß',
    synthetisch: 'Synthetisch', wuerzig: 'Würzig', zitrus: 'Zitrus'
  };
  /* „Welche Duftrichtung magst du?“ → Dufttyp-Schlüssel mit Gewicht */
  var FAMILIES = {
    suess:    { gourmand: 1, suess: 1, cremig: 0.9 },
    frisch:   { frisch: 1, zitrus: 1, aquatisch: 1, gruen: 0.8 },
    blumig:   { blumig: 1, pudrig: 1 },
    fruchtig: { fruchtig: 1 },
    holzig:   { holzig: 1, erdig: 1 },
    wuerzig:  { wuerzig: 1, orientalisch: 1, harzig: 0.7 },
    dunkel:   { rauchig: 1, ledrig: 1, animalisch: 1, harzig: 0.5 }
  };
  /* Mindestanteil (in %) einer gewählten Richtung, damit ein Duft als „passend“ gilt */
  var FAM_MIN = { suess: 35, frisch: 30, blumig: 18, fruchtig: 15, holzig: 14, wuerzig: 22, dunkel: 12 };
  /* „Was magst du gar nicht?“ */
  var AVOID = {
    suess:  { gourmand: 1, suess: 1, cremig: 1 },
    blumig: { blumig: 1, pudrig: 1 },
    frisch: { frisch: 1, zitrus: 1, aquatisch: 1, gruen: 1 },
    schwer: { orientalisch: 1, harzig: 1, rauchig: 1, ledrig: 1, animalisch: 1 }
  };
  /* Nie-Regeln: Wer nur diese Richtung wählt, bekommt keine Düfte mit mehr als x % der Gegenrichtung */
  var OPPOSITE = {
    suess:   { frisch: 15 },
    frisch:  { suess: 30, schwer: 15 },
    wuerzig: { frisch: 25 },
    dunkel:  { frisch: 20 }
  };
  var SEASON_KEYS = ['fruehling', 'sommer', 'herbst', 'winter'];
  var OCCASIONS = {
    alltag:   { taeglich: 1, freizeit: 0.4, arbeit: 0.4 },
    buero:    { arbeit: 1, taeglich: 0.5 },
    freizeit: { freizeit: 1, sport: 1, taeglich: 0.3 },
    abend:    { abend: 1, ausgehen: 1 }
  };
  /* Gewichte der Teilwerte (je 0–1) */
  var W = { fam: 0.40, season: 0.18, occ: 0.15, gender: 0.15, pop: 0.06, avoid: 0.40, ref: 0.40, famWithRef: 0.15 };
  /* Lieblingsduft: so ähnlich (Überschneidung der Dufttyp-Anteile) gilt ein Duft auch ohne Mindestanteil der Richtung als passend */
  var REF_OK = 0.65;
  /* Platzhalter-Profile: Dufttyp-Werte nach festem Rangmuster statt Messung (z. B. 37/27/21/15) – eine Stufe zurück */
  var TEMPLATES = ['58,42', '43,32,25', '37,27,21,15', '34,25,19,13,9', '32,23,18,13,9,5'];
  var TEMPLATE_PENALTY = 0.05;
  /* Stufen der harten Bedingungen, von streng nach locker.
     fam = Anteil der gewählten Richtung als Vielfaches von FAM_MIN, avoid = Höchstanteil ausgeschlossener Noten,
     opp = Nie-Regeln, g = Stil (2 streng, 1 locker, 0 egal), s = Jahreszeit (2 streng, 1 locker, 0 egal), o = Anlass muss passen */
  var STAGES = [
    { fam: 1, avoid: 0.20, opp: 1, g: 2, s: 2, o: 1 },
    { fam: 1, avoid: 0.20, opp: 1, g: 2, s: 2, o: 0 },
    { fam: 1, avoid: 0.20, opp: 1, g: 2, s: 1, o: 1 },
    { fam: 1, avoid: 0.20, opp: 1, g: 2, s: 1, o: 0 },
    { fam: 1, avoid: 0.20, opp: 1, g: 2, s: 0, o: 0 },
    { fam: 0.75, avoid: 0.20, opp: 1, g: 1, s: 1, o: 0 },
    { fam: 0.75, avoid: 0.20, opp: 1, g: 1, s: 0, o: 0 },
    { fam: 0.5, avoid: 0.30, opp: 0, g: 1, s: 0, o: 0 },
    { fam: 0.5, avoid: 0.30, opp: 0, g: 0, s: 0, o: 0 },
    { fam: 0, avoid: 9, opp: 0, g: 0, s: 0, o: 0 }
  ];
  /* Stil: r = Damen / (Damen + Herren). Streng = deutlich passende Seite, locker = Vertragsgrenzen (Zielgruppe) */
  var STIL = { sieStrict: 0.45, sieLoose: 0.35, ihnStrict: 0.55, ihnLoose: 0.65, unisexLo: 0.35, unisexHi: 0.65 };
  var SEASON_TOLERANCE = 12;   /* streng: gewählte Jahreszeit höchstens so viele Prozentpunkte unter der stärksten */
  var SEASON_LOOSE = 22;       /* locker */
  var DIV = { sim: 0.18, vendor: 0.08, line: 1.5 };
  var NOTE_SKIP = { synthetisch: 1 };

  function weighted(map, weights) {
    var s = 0;
    for (var k in weights) if (map && map[k]) s += map[k] * weights[k];
    return s;
  }
  function shares(map) {
    var sum = 0, out = {}, k;
    for (k in map) sum += +map[k] || 0;
    if (!sum) return {};
    for (k in map) out[k] = 100 * (+map[k] || 0) / sum;
    return out;
  }
  function quantile(values, q) {
    var xs = values.slice().sort(function (a, b) { return a - b; });
    if (!xs.length) return 0;
    return xs[Math.min(xs.length - 1, Math.round(q * (xs.length - 1)))];
  }
  function overlap(a, b) {
    var s = 0;
    for (var k in a) if (b && b[k]) s += Math.min(a[k], b[k]);
    return s / 100;
  }
  function lineKey(item) {
    var first = String(item.t || '').toLowerCase().replace(/[^a-z0-9äöüß ]/g, ' ').trim().split(/\s+/)[0] || '';
    return String(item.b || '').toLowerCase() + '|' + first;
  }

  /* Katalog vorbereiten: Anteile bilden, Referenzwerte (95. Perzentil = „typischer Vertreter“) einmal berechnen.
     all = alle Düfte mit Profil (Suche nach Lieblingsduft), items = davon mit lieferbarer 2-ml-Probe (Empfehlungen) */
  function prepare(catalog) {
    var all = [];
    (catalog || []).forEach(function (raw) {
      if (!raw || !raw.d) return;
      var d = shares(raw.d);
      if (!Object.keys(d).length) return;
      var y = raw.y || {}, dh = (+y.damen || 0) + (+y.herren || 0);
      var pattern = Object.keys(raw.d).map(function (k) { return +raw.d[k] || 0; })
        .sort(function (a, b) { return b - a; }).join(',');
      all.push({
        src: raw, h: raw.h, t: raw.t, b: raw.b, r: raw.r,
        d: d, s: shares(raw.s || {}), o: shares(raw.o || {}),
        g: dh ? (+y.damen || 0) / dh : 0.5,
        tpl: TEMPLATES.indexOf(pattern) > -1
      });
    });
    var items = all.filter(function (it) { return it.src.a; });
    var full = {}, occFull = {}, seasonFull = {};
    Object.keys(FAMILIES).forEach(function (f) {
      full[f] = Math.max(1, quantile(items.map(function (it) { return weighted(it.d, FAMILIES[f]); }), 0.95));
    });
    Object.keys(OCCASIONS).forEach(function (o) {
      occFull[o] = Math.max(1, quantile(items.map(function (it) { return weighted(it.o, OCCASIONS[o]); }), 0.95));
    });
    SEASON_KEYS.forEach(function (s) {
      seasonFull[s] = Math.max(1, quantile(items.map(function (it) { return it.s[s] || 0; }), 0.95));
    });
    var maxRank = items.reduce(function (m, it) { return Math.max(m, it.r == null ? 0 : it.r); }, 1);
    var byHandle = {};
    all.forEach(function (it) { byHandle[it.h] = it; });
    return { all: all, items: items, full: full, occFull: occFull, seasonFull: seasonFull, maxRank: maxRank, byHandle: byHandle };
  }

  function famValues(item, fams, ctx) {
    return fams.map(function (f) { return Math.min(1, weighted(item.d, FAMILIES[f]) / ctx.full[f]); });
  }
  function famScore(vals) {
    if (!vals.length) return 0.5;
    if (vals.length === 1) return vals[0];
    var hi = Math.max(vals[0], vals[1]), lo = Math.min(vals[0], vals[1]);
    return ((vals[0] + vals[1]) / 2) * (0.55 + 0.45 * (hi ? lo / hi : 0));
  }
  function famRel(item, fams) {
    return fams.map(function (f) { return weighted(item.d, FAMILIES[f]) / FAM_MIN[f]; });
  }
  function famOk(rel, k) {
    if (!rel.length || !k) return true;
    if (rel.length === 1) return rel[0] >= k;
    return Math.max(rel[0], rel[1]) >= k && Math.min(rel[0], rel[1]) >= k / 2;
  }
  /* Nie-Regeln gelten nur, wenn alle gewählten Richtungen sie haben (z. B. nicht bei „süß + frisch“) */
  function oppositeOk(item, fams) {
    if (!fams.length) return true;
    var rules = OPPOSITE[fams[0]] || {};
    for (var x in rules) {
      if (fams.indexOf(x) > -1) continue;
      var max = 0, all = true;
      fams.forEach(function (f) { var r = OPPOSITE[f] || {}; if (r[x] == null) all = false; else max = Math.max(max, r[x]); });
      if (all && weighted(item.d, AVOID[x]) > max) return false;
    }
    return true;
  }
  function avoidShare(item, avoid) {
    var s = 0;
    avoid.forEach(function (a) { s += weighted(item.d, AVOID[a]); });
    return s / 100;
  }
  function seasonInfo(item, season, ctx) {
    var vals = SEASON_KEYS.map(function (k) { return item.s[k] || 0; });
    var max = Math.max.apply(null, vals), min = Math.min.apply(null, vals);
    if (!max) return { score: 0.5, strict: true, loose: true };
    if (!season || season === 'ganzjaehrig') return { score: Math.min(1, (min / max) / 0.6), strict: min >= 10, loose: min >= 5 };
    var v = item.s[season] || 0;
    return { score: 0.5 * Math.min(1, v / ctx.seasonFull[season]) + 0.5 * (v / max), strict: v >= max - SEASON_TOLERANCE, loose: v >= max - SEASON_LOOSE };
  }
  function occInfo(item, occ, ctx) {
    if (!occ || !OCCASIONS[occ]) return { score: 0.5, ok: true };
    var o = item.o, g = function (k) { return o[k] || 0; };
    var eve = g('abend') + g('ausgehen');
    var ok = occ === 'abend' ? eve >= g('taeglich') + g('arbeit')
      : occ === 'buero' ? g('arbeit') + g('taeglich') >= eve
      : occ === 'freizeit' ? g('freizeit') + g('sport') + g('taeglich') >= eve
      : g('taeglich') + g('freizeit') + g('arbeit') >= eve;
    return { score: Math.min(1, weighted(o, OCCASIONS[occ]) / ctx.occFull[occ]), ok: ok };
  }
  /* level 2 = streng, 1 = locker */
  function genderInfo(item, who) {
    var r = item.g;
    if (who === 'sie') return { score: r, strict: r >= STIL.sieStrict, loose: r >= STIL.sieLoose };
    if (who === 'ihn') return { score: 1 - r, strict: r <= STIL.ihnStrict, loose: r <= STIL.ihnLoose };
    if (who === 'unisex') {
      var ok = r > STIL.unisexLo && r < STIL.unisexHi;
      return { score: 1 - Math.abs(2 * r - 1), strict: ok, loose: r > 0.25 && r < 0.75 };
    }
    return { score: 1, strict: true, loose: true };
  }

  function evaluate(ctx, a) {
    var fams = (a.fam || []).filter(function (f) { return FAMILIES[f]; }).slice(0, 2);
    var avoid = (a.avoid || []).filter(function (x) { return AVOID[x] && fams.indexOf(x) === -1; });
    var ref = a.ref ? ctx.byHandle[a.ref] : null;
    var refLo = 0, refHi = 1, refLine = null;
    if (ref) {
      refLine = lineKey(ref);
      var ovs = ctx.items.filter(function (it) { return it.h !== ref.h && lineKey(it) !== refLine; })
        .map(function (it) { return overlap(it.d, ref.d); });
      refLo = quantile(ovs, 0.5);
      refHi = Math.max(refLo + 0.05, quantile(ovs, 1));
    }
    var out = [];
    ctx.items.forEach(function (it) {
      if (ref && (it.h === ref.h || lineKey(it) === refLine)) return;
      var fv = famValues(it, fams, ctx), rel = famRel(it, fams), opp = oppositeOk(it, fams);
      var se = seasonInfo(it, a.season, ctx), oc = occInfo(it, a.occ, ctx), ge = genderInfo(it, a.who);
      var parts = {
        fam: famScore(fv),
        avoid: avoidShare(it, avoid),
        season: se.score,
        occ: oc.score,
        gender: ge.score,
        pop: 1 - (it.r == null ? ctx.maxRank : it.r) / ctx.maxRank,
        ref: 0
      };
      var refOv = ref ? overlap(it.d, ref.d) : 0;
      if (ref) parts.ref = Math.max(0, Math.min(1, (refOv - refLo) / (refHi - refLo)));
      var score = (ref ? W.famWithRef : W.fam) * parts.fam + W.season * parts.season + W.occ * parts.occ +
        W.gender * parts.gender + W.pop * parts.pop + (ref ? W.ref * parts.ref : 0) -
        W.avoid * Math.max(0, Math.min(1, (parts.avoid - 0.08) / 0.27)) - (it.tpl ? TEMPLATE_PENALTY : 0);
      var tier = STAGES.length - 1;
      for (var i = 0; i < STAGES.length; i++) {
        var st = STAGES[i];
        var gOk = st.g === 2 ? ge.strict : st.g === 1 ? ge.loose : true;
        var sOk = st.s === 2 ? se.strict : st.s === 1 ? se.loose : true;
        var fOk = famOk(rel, st.fam) || (ref && st.fam && refOv >= REF_OK);
        if (fOk && parts.avoid <= st.avoid && (!st.opp || opp) && gOk && sOk && (!st.o || oc.ok)) { tier = i; break; }
      }
      if (it.tpl) tier = Math.min(STAGES.length - 1, tier + 1);
      out.push({ item: it.src, prepared: it, score: score, tier: tier, parts: parts });
    });
    return out;
  }

  function pickDiverse(scored, n) {
    var sorted = scored.slice().sort(function (x, y) { return (x.tier - y.tier) || (y.score - x.score); });
    var picked = [];
    while (picked.length < n && sorted.length) {
      var best = null, bestVal = -Infinity;
      for (var i = 0; i < Math.min(sorted.length, 60); i++) {
        var c = sorted[i], sim = 0, sameVendor = 0, sameLine = false;
        for (var j = 0; j < picked.length; j++) {
          var p = picked[j];
          sim = Math.max(sim, overlap(c.prepared.d, p.prepared.d));
          if (p.item.b === c.item.b) sameVendor++;
          if (lineKey(p.item) === lineKey(c.item)) sameLine = true;
        }
        var val = c.score - c.tier - DIV.sim * sim - DIV.vendor * sameVendor - (sameLine ? DIV.line : 0);
        if (val > bestVal) { bestVal = val; best = c; }
      }
      picked.push(best);
      sorted.splice(sorted.indexOf(best), 1);
    }
    return picked;
  }

  /* Haupteinstieg: answers = { who: sie|ihn|unisex|egal, fam: [..], avoid: [..], season, occ, ref } */
  function recommend(ctxOrCatalog, answers, n) {
    var ctx = ctxOrCatalog && ctxOrCatalog.items ? ctxOrCatalog : prepare(ctxOrCatalog);
    return pickDiverse(evaluate(ctx, answers || {}), n || 3);
  }

  /* Die stärksten Duftnoten eines Katalog-Eintrags als Anzeige-Labels („Süß, Gourmand“) */
  function topNotes(item, count) {
    var d = item.d || {};
    return Object.keys(d).filter(function (k) { return !NOTE_SKIP[k] && d[k] > 0; })
      .sort(function (x, y) { return d[y] - d[x]; }).slice(0, count || 2)
      .map(function (k) { return LABELS[k] || k; });
  }

  return {
    LABELS: LABELS, FAMILIES: FAMILIES, FAM_MIN: FAM_MIN, OPPOSITE: OPPOSITE, AVOID: AVOID, OCCASIONS: OCCASIONS,
    W: W, STAGES: STAGES, STIL: STIL, TEMPLATES: TEMPLATES, REF_OK: REF_OK,
    prepare: prepare, evaluate: evaluate, recommend: recommend, overlap: overlap, shares: shares,
    topNotes: topNotes, lineKey: lineKey, weighted: weighted
  };
});
